import type { WinnersFeedDailyTotalsDto, WinnersFeedItemDto } from "./winnersFeed.types";

export const USE_FEED_MOCKS = false;
export const USE_CATEGORIES_MOCKS = false;

export const MULTI_PRIZE_COMPETITION_ID = 6092;
export const SINGLE_PRIZE_COMPETITION_ID = 6096;

const MOCK_FEED_ITEMS: WinnersFeedItemDto[] = [
  {
    PrizeName: "£500 Cash",
    WinnerDisplayName: "Kyle M.",
    PrizeValueGBP: 500.0,
    IsCashPrize: true,
    TicketPriceGBP: 0.0,
    RevealedAtUTC: "2026-04-05T21:31:10.59",
    RevealedText: "Revealed today",
    Priority: "Aspirational",
    ThumbnailUrl: "https://cdn.botb.com/media/acodhhhn/29-500.png",
    CompetitionTypePrefix: "SC",
    Location: "",
    NavigationColour: "navigation-dark-blue",
    CompetitionId: 6043,
    WinnerThumbnailUrl: null,
    IsBotbPass: true,
    PassType: "Premium",
  },
  {
    PrizeName: "iPhone 17",
    WinnerDisplayName: "Anjali M.",
    PrizeValueGBP: 799.0,
    IsCashPrize: false,
    TicketPriceGBP: 0.0,
    RevealedAtUTC: "2026-04-05T21:31:09.607",
    RevealedText: "Revealed today",
    Priority: "Aspirational",
    ThumbnailUrl: "https://cdn.botb.com/media/deklnbjo/botb-8934-thumbnail-iphone-17.webp",
    CompetitionTypePrefix: "SC",
    Location: "",
    NavigationColour: "navigation-dark-blue",
    CompetitionId: 6043,
    WinnerThumbnailUrl: null,
    IsBotbPass: true,
    PassType: "Essential",
  },
  {
    PrizeName: "Rolex Datejust",
    WinnerDisplayName: "Luke A.",
    PrizeValueGBP: 4400.0,
    IsCashPrize: false,
    TicketPriceGBP: 1.49,
    RevealedAtUTC: "2026-04-04T22:27:25.07",
    RevealedText: "Revealed yesterday",
    Priority: "Aspirational",
    ThumbnailUrl: "https://cdn.botb.com/media/ybva10gv/12-rolex-datejust.png",
    CompetitionTypePrefix: "IB",
    Location: "",
    NavigationColour: "navigation-purple",
    CompetitionId: SINGLE_PRIZE_COMPETITION_ID,
    WinnerThumbnailUrl: null,
    IsBotbPass: false,
    PassType: null,
  },
  {
    PrizeName: "£500 Cash",
    WinnerDisplayName: "Olesea_ I.",
    PrizeValueGBP: 500.0,
    IsCashPrize: true,
    TicketPriceGBP: 0.0,
    RevealedAtUTC: "2026-04-04T21:26:10.327",
    RevealedText: "Revealed yesterday",
    Priority: "Aspirational",
    ThumbnailUrl: "https://cdn.botb.com/media/acodhhhn/29-500.png",
    CompetitionTypePrefix: "SC",
    Location: "",
    NavigationColour: "navigation-dark-blue",
    CompetitionId: 6042,
    WinnerThumbnailUrl: null,
    IsBotbPass: true,
    PassType: "Ultimate",
  },
  {
    PrizeName: "iPhone 17",
    WinnerDisplayName: "Ioan R.",
    PrizeValueGBP: 799.0,
    IsCashPrize: false,
    TicketPriceGBP: 0.0,
    RevealedAtUTC: "2026-04-04T21:26:08.95",
    RevealedText: "Revealed yesterday",
    Priority: "Aspirational",
    ThumbnailUrl: "https://cdn.botb.com/media/deklnbjo/botb-8934-thumbnail-iphone-17.webp",
    CompetitionTypePrefix: "SC",
    Location: "",
    NavigationColour: "navigation-dark-blue",
    CompetitionId: 6042,
    WinnerThumbnailUrl: null,
    IsBotbPass: true,
    PassType: "Ultimate",
  },
  {
    PrizeName: "£500 Cash",
    WinnerDisplayName: "Mudaser R.",
    PrizeValueGBP: 500.0,
    IsCashPrize: true,
    TicketPriceGBP: 0.0,
    RevealedAtUTC: "2026-04-03T21:26:09.437",
    RevealedText: "Revealed 2 days ago",
    Priority: "Aspirational",
    ThumbnailUrl: "https://cdn.botb.com/media/acodhhhn/29-500.png",
    CompetitionTypePrefix: "SC",
    Location: "",
    NavigationColour: "navigation-dark-blue",
    CompetitionId: 6041,
    WinnerThumbnailUrl: null,
    IsBotbPass: true,
    PassType: "Ultimate",
  },
  {
    PrizeName: "Jeep Wrangler",
    WinnerDisplayName: "Andrew N.",
    PrizeValueGBP: 38000.0,
    IsCashPrize: false,
    TicketPriceGBP: 1.69,
    RevealedAtUTC: "2026-04-03T19:26:15.79",
    RevealedText: "Revealed 2 days ago",
    Priority: "Headline",
    ThumbnailUrl: "https://cdn.botb.com/media/450cu0iq/7-jeep-wrangler.png",
    CompetitionTypePrefix: "IB",
    Location: "",
    NavigationColour: "navigation-purple",
    CompetitionId: 6027,
    WinnerThumbnailUrl: null,
    IsBotbPass: false,
    PassType: null,
  },
  {
    PrizeName: "MSI Gaming Laptop",
    WinnerDisplayName: "Sarah T.",
    PrizeValueGBP: 1200.0,
    IsCashPrize: false,
    TicketPriceGBP: 0.59,
    RevealedAtUTC: "2026-04-03T18:15:00.00",
    RevealedText: "Revealed 2 days ago",
    Priority: "Aspirational",
    ThumbnailUrl: "https://cdn.botb.com/media/acodhhhn/29-500.png",
    CompetitionTypePrefix: "EW",
    Location: "London",
    NavigationColour: "navigation-green",
    CompetitionId: 7001,
    WinnerThumbnailUrl: null,
    IsBotbPass: false,
    PassType: null,
  },
  {
    PrizeName: "Porsche 911 GT3",
    WinnerDisplayName: "James K.",
    PrizeValueGBP: 165000.0,
    IsCashPrize: false,
    TicketPriceGBP: 1.99,
    RevealedAtUTC: "2026-04-03T17:00:00.00",
    RevealedText: "Revealed 2 days ago",
    Priority: "Headline",
    ThumbnailUrl: "https://cdn.botb.com/media/450cu0iq/7-jeep-wrangler.png",
    CompetitionTypePrefix: "IW",
    Location: "Manchester",
    NavigationColour: "navigation-purple",
    CompetitionId: 7002,
    WinnerThumbnailUrl: null,
    IsBotbPass: false,
    PassType: null,
  },
  {
    PrizeName: "BMW M4 Competition",
    WinnerDisplayName: "Emma W.",
    PrizeValueGBP: 82000.0,
    IsCashPrize: false,
    TicketPriceGBP: 2.49,
    RevealedAtUTC: "2026-04-03T15:30:00.00",
    RevealedText: "Revealed 2 days ago",
    Priority: "Headline",
    ThumbnailUrl: "https://cdn.botb.com/media/ybva10gv/12-rolex-datejust.png",
    CompetitionTypePrefix: "DC",
    Location: "Birmingham",
    NavigationColour: "navigation-red",
    CompetitionId: 7003,
    WinnerThumbnailUrl: null,
    IsBotbPass: false,
    PassType: null,
  },
  {
    PrizeName: "Mercedes AMG GT",
    WinnerDisplayName: "Tom B.",
    PrizeValueGBP: 95000.0,
    IsCashPrize: false,
    TicketPriceGBP: 1.89,
    RevealedAtUTC: "2026-04-03T14:00:00.00",
    RevealedText: "Revealed 2 days ago",
    Priority: "Headline",
    ThumbnailUrl: "https://cdn.botb.com/media/450cu0iq/7-jeep-wrangler.png",
    CompetitionTypePrefix: "IB",
    Location: "Bristol",
    NavigationColour: "navigation-purple",
    CompetitionId: 7004,
    WinnerThumbnailUrl: "https://cdn.botb.com/media/deklnbjo/botb-8934-thumbnail-iphone-17.webp",
    IsBotbPass: false,
    PassType: null,
  },
];

const MOCK_DAILY_TOTALS: WinnersFeedDailyTotalsDto = {
  TotalPrizesToday: 3241,
  TotalWinnersToday: 2847,
  TotalValueWonTodayGBP: 1_284_500,
};

export function getMockFeedItems(): WinnersFeedItemDto[] {
  return MOCK_FEED_ITEMS;
}

export function getMockDailyTotals(): WinnersFeedDailyTotalsDto {
  return MOCK_DAILY_TOTALS;
}
